import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthCallout({ feature }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="auth-callout">
      <div>
        <strong>Sign in required.</strong> Public beta keeps {feature} behind account-based limits and audit history.
      </div>
      <Link to="/login?mode=signin" state={{ from: location }} className="btn btn-primary">
        Sign In to Continue
      </Link>
    </div>
  );
}
